const getUserNameInitialLetters = (name: string) => {
  const names = name.split(/\s+/)
  const firstName = names?.[0]
  const lastName = names.slice(-1)?.[0]

  if (names.length > 1) {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
  }

  return `${firstName.slice(0, 2)}`.toUpperCase()
}

export default getUserNameInitialLetters
